import { forwardRef, createElement } from 'react';

function IconPeriod(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M20.25 6c.966 0 1.75.784 1.75 1.75v12.5A1.75 1.75 0 0120.25 22H7.75A1.75 1.75 0 016 20.25V19h1.5v1.25a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V7.75a.25.25 0 00-.193-.243L20.25 7.5H19V6h1.25zm-7-5a.75.75 0 01.75.75V2h2.25c.966 0 1.75.784 1.75 1.75v12.5A1.75 1.75 0 0116.25 18H3.75A1.75 1.75 0 012 16.25V3.75C2 2.784 2.784 2 3.75 2H6v-.25a.75.75 0 011.5 0V2h5v-.25a.75.75 0 01.75-.75zm3.25 6.5h-13v8.75a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V7.5zm-6.195 1.277c.38 0 .62.21.662.554l.006.107v4.554c0 .356-.235.59-.582.59-.313 0-.538-.19-.58-.487l-.006-.103V9.957H9.78l-.824.574a.48.48 0 01-.312.106.402.402 0 01-.415-.422c0-.15.05-.267.172-.377l.082-.065L9.602 9a1.09 1.09 0 01.703-.223zM6 3.5H3.75a.25.25 0 00-.243.193L3.5 3.75V6h13V3.75a.25.25 0 00-.193-.243L16.25 3.5H14v.25a.75.75 0 11-1.5 0V3.5h-5v.25a.75.75 0 01-1.5 0V3.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Period = /*#__PURE__*/forwardRef(IconPeriod);

export default Period;
//# sourceMappingURL=Period.js.map
